import React from 'react';
import { observer } from 'mobx-react';
import { StyledDropdown } from './ReplenishmentDropdownStyles';
interface IReplenishmentDropdownProps {
    replenishmentOptions: { label: string; value: string; is_chosen: boolean }[];
    selectedValue: string;
    setSelected(newVal: string): string;
    isLoading?: boolean;
}

export const ReplenishmentDropdown = observer(
    ({
        replenishmentOptions,
        selectedValue,
        setSelected,
        isLoading = false
    }: IReplenishmentDropdownProps) => {
        const onDropdownChange = ({
            target: { value = '' }
        }: React.ChangeEvent<HTMLSelectElement>) => selectedValue !== value && setSelected(value);

        return (
            <StyledDropdown
                className={'auto-replenishment'}
                data-test-id={'auto-replenishment-test-id'}
                isDisabled={isLoading}
                options={replenishmentOptions}
                selectedOption={selectedValue}
                onChange={onDropdownChange}
                isRequired={true}
            />
        );
    }
);
